export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-link-e732ede7d74e42eed2ee7be4d11306d5.svg";